const updatedByUserType = {
  SHIPPER: 1,
  TRANSPORTER: 2,
  SYSTEM: 3,
};

module.exports = {
  updatedByUserType,
};

